<div class="min-h-screen relative overflow-hidden">
  <div class="relative z-10 p-6">
    <!-- HERO -->
    <div class="grid grid-cols-1 xl:grid-cols-12 gap-5 mb-6">
      <!-- HERO -->
      <div
        class="ai-engine xl:col-span-8 rounded-3xl overflow-hidden relative bg-gradient-to-br from-blue-500 via-indigo-500 to-purple-500 dark:from-slate-950 dark:via-blue-950 dark:to-indigo-950 p-8 text-white"
      >
        <!-- Decorative Glow -->
        <div
          class="absolute top-0 right-0 w-72 h-72 bg-white/10 dark:bg-cyan-500/10 rounded-full blur-3xl"
        ></div>

        <div
          class="absolute bottom-0 left-0 w-72 h-72 bg-purple-300/20 dark:bg-purple-500/10 rounded-full blur-3xl"
        ></div>

        <div class="relative z-10 grid xl:grid-cols-2 gap-8 items-center">
          <!-- LEFT CONTENT -->

          <div>
            <span
              class="inline-flex items-center px-4 py-1 rounded-full bg-white/20 dark:bg-cyan-500/10 border border-white/20 dark:border-cyan-500/20 text-sm"
            >
              AI Powered EDI Platform
            </span>

            <h1 class="text-4xl xl:text-5xl font-bold mt-5 leading-tight">
              Welcome to

              <span class="text-yellow-200 dark:text-cyan-400">
                EDI Verse
              </span>
            </h1>

            <p class="mt-4 max-w-xl text-blue-50 dark:text-slate-300">
              The next generation EDI ecosystem enabling partner onboarding,
              intelligent AI mapping, connectivity management and transaction
              monitoring.
            </p>
          </div>

          <!-- RIGHT AI FLOW -->

          <div>
            <div class="flex items-center justify-between gap-4">
              <!-- INPUTS -->

              <div class="space-y-4">
                <div
                  class="bg-white/15 dark:bg-slate-900/80 border border-white/20 dark:border-cyan-500/20 px-5 py-3 rounded-xl"
                >
                  JSON
                </div>

                <div
                  class="bg-white/15 dark:bg-slate-900/80 border border-white/20 dark:border-cyan-500/20 px-5 py-3 rounded-xl"
                >
                  XML
                </div>

                <div
                  class="bg-white/15 dark:bg-slate-900/80 border border-white/20 dark:border-cyan-500/20 px-5 py-3 rounded-xl"
                >
                  CSV
                </div>
              </div>

              <!-- AI ENGINE -->

              <div
                class="relative w-32 h-32 rounded-full border-4 border-white/40 dark:border-cyan-500 flex items-center justify-center"
              >
                <div
                  class="absolute inset-0 rounded-full bg-cyan-500/20 blur-xl"
                ></div>

                <div class="relative text-center">
                  <div class="text-4xl">🧠</div>

                  <div class="text-xs mt-1 text-blue-100 dark:text-cyan-300">
                    AI ENGINE
                  </div>
                </div>
              </div>

              <!-- OUTPUTS -->

              <div class="space-y-4">
                <div
                  class="bg-white/15 dark:bg-slate-900/80 border border-white/20 dark:border-cyan-500/20 px-5 py-3 rounded-xl"
                >
                  X12
                </div>

                <div
                  class="bg-white/15 dark:bg-slate-900/80 border border-white/20 dark:border-cyan-500/20 px-5 py-3 rounded-xl"
                >
                  EDIFACT
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- KPI SECTION -->
      <div class="xl:col-span-4">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 h-full">
          @for (item of stats; track item.title) {
            <div
              class="group relative bg-white dark:bg-slate-900 rounded-2xl p-5 border border-slate-200 dark:border-slate-800 shadow-sm hover:-translate-y-1 hover:shadow-xl transition-all duration-300 overflow-hidden"
            >
              <!-- Subtle Gradient Hover Effect -->
              <div
                class="absolute inset-0 opacity-0 group-hover:opacity-[0.05] transition-opacity duration-300 pointer-events-none"
                [ngClass]="{
                  'bg-gradient-to-br from-blue-500 to-blue-600':
                    item.theme === 'blue',
                  'bg-gradient-to-br from-green-500 to-green-600':
                    item.theme === 'green',
                  'bg-gradient-to-br from-amber-500 to-amber-600':
                    item.theme === 'amber',
                  'bg-gradient-to-br from-red-500 to-red-600':
                    item.theme === 'red',
                }"
              ></div>

              <div class="relative z-10">
                <!-- Icon Badge + Title Row -->
                <div class="flex items-center gap-3 mb-3">
                  <!-- Themed Icon Badge -->
                  <div
                    class="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 transition-transform group-hover:scale-105"
                    [ngClass]="{
                      'bg-blue-100 text-blue-600 dark:bg-blue-500/20 dark:text-blue-400':
                        item.theme === 'blue',
                      'bg-green-100 text-green-600 dark:bg-green-500/20 dark:text-green-400':
                        item.theme === 'green',
                      'bg-amber-100 text-amber-600 dark:bg-amber-500/20 dark:text-amber-400':
                        item.theme === 'amber',
                      'bg-red-100 text-red-600 dark:bg-red-500/20 dark:text-red-400':
                        item.theme === 'red',
                    }"
                  >
                    <i
                      class="pi text-2xl"
                      [ngClass]="item.icon"
                      style="font-size: 1.3rem"
                    ></i>
                  </div>

                  <!-- Title -->
                  <div
                    class="text-sm font-medium text-slate-600 dark:text-slate-400 flex-1"
                  >
                    {{ item.title }}
                  </div>
                </div>

                <!-- Value -->
                <div
                  class="text-3xl font-bold text-slate-800 dark:text-white tracking-tight mb-2"
                >
                  {{ item.value }}
                </div>

                <!-- Growth Indicator -->
                <div class="flex items-center gap-1">
                  <span
                    class="text-sm font-semibold text-green-600 dark:text-green-500 flex items-center gap-1"
                    [ngClass]="
                      item.isPositive ? 'text-green-600' : 'text-red-600'
                    "
                  >
                    <i
                      class="pi text-xs"
                      [ngClass]="
                        item.isPositive ? 'pi-arrow-up' : 'pi-arrow-down'
                      "
                    ></i>
                    {{ item.growth }}
                  </span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <!-- CHARTS SECTION -->
    <div class="grid xl:grid-cols-3 gap-6 mt-6">
      <!-- BAR CHART -->

      <div
        class="xl:col-span-2 rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg dark:shadow-[0_0_40px_rgba(70,95,255,0.15)] p-6 h-[430px]"
      >
        <div class="flex justify-between mb-6">
          <h3 class="text-xl font-semibold text-slate-800 dark:text-white">
            Transaction Overview
          </h3>

          <div
            class="px-3 py-1 rounded-lg bg-blue-100 text-blue-700 dark:bg-indigo-500/10 dark:text-indigo-300"
          >
            Last 7 Days
          </div>
        </div>

        <div class="flex flex-col h-full">
          <app-bar-chart-one />

          <div class="grid grid-cols-3 gap-4 mt-15">
            <!-- Success -->
            <div
              class="rounded-2xl p-4 bg-green-50 dark:bg-green-500/10 border border-green-200 dark:border-green-500/20 shadow-md dark:shadow-[0_0_20px_rgba(34,197,94,0.15)] hover:dark:shadow-[0_0_30px_rgba(34,197,94,0.25)] transition-all duration-300"
            >
              <div class="text-xs text-green-600 dark:text-green-400">
                Transaction Success Rate
              </div>

              <div
                class="text-2xl font-bold text-green-600 dark:text-green-400 mt-2"
              >
                96.4%
              </div>
            </div>

            <!-- Pending -->
            <div
              class="rounded-2xl p-4 bg-amber-50 dark:bg-amber-500/10 border border-amber-200 dark:border-amber-500/20 shadow-md dark:shadow-[0_0_20px_rgba(251,199,13,0.15)] hover:dark:shadow-[0_0_30px_rgba(251,199,13,0.25)] transition-all duration-300"
            >
              <div class="text-xs text-amber-600 dark:text-amber-400">
                Transaction Pending Rate
              </div>

              <div
                class="text-2xl font-bold text-amber-600 dark:text-amber-400 mt-2"
              >
                2.4%
              </div>
            </div>

            <!-- Failed -->
            <div
              class="rounded-2xl p-4 bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 shadow-md dark:shadow-[0_0_20px_rgba(239,68,68,0.15)] hover:dark:shadow-[0_0_30px_rgba(239,68,68,0.25)] transition-all duration-300"
            >
              <div class="text-xs text-red-600 dark:text-red-400">
                Transaction Failed Rate
              </div>

              <div
                class="text-2xl font-bold text-red-600 dark:text-red-400 mt-2"
              >
                1.2%
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-6">
        <!-- Transactions -->

        <div
          class="rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg dark:shadow-[0_0_40px_rgba(70,95,255,0.15)] p-5"
        >
          <h3 class="text-lg font-semibold mb-4 dark:text-white">
            Transactions by Type
          </h3>

          <app-pie-chart
            [series]="transactionSeries"
            [labels]="transactionLabels"
            [colors]="transactionColors"
            [totalLabel]="'Transactions'"
            [totalValue]="'1,248'"
          />
        </div>

        <!-- Formats -->

        <div
          class="rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg dark:shadow-[0_0_40px_rgba(70,95,255,0.15)] p-5"
        >
          <h3 class="text-lg font-semibold mb-4 dark:text-white">
            File Format Distribution
          </h3>

          <app-pie-chart
            [series]="fileSeries"
            [labels]="fileLabels"
            [colors]="fileColors"
            [totalLabel]="'Formats'"
            [totalValue]="'100%'"
          />
        </div>
      </div>
    </div>

    <!-- TRANSACTION TABLE -->

    <div
      class="mt-8 rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg dark:shadow-[0_0_40px_rgba(70,95,255,0.15)] p-6"
    >
      <h3 class="text-xl font-semibold mb-4 dark:text-white">
        Recent Transactions
      </h3>

      <div class="overflow-x-auto">
        <table class="w-full">
          <thead>
            <tr class="border-b border-slate-200 dark:border-slate-800">
              <th class="text-left py-3">Partner</th>
              <th class="text-left py-3">Connectivity</th>
              <th class="text-left py-3">Source Format</th>
              <th class="text-left py-3">Target Format</th>
              <th class="text-left py-3">Status</th>
            </tr>
          </thead>

          <tbody>
            <tr class="border-b border-slate-100 dark:border-slate-800">
              <td class="py-4">Company A</td>
              <td class="py-4">SFTP</td>
              <td>X12</td>
              <td>JSON</td>
              <td>
                <span
                  class="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-green-100 text-green-700 dark:bg-green-500/15 dark:text-green-400 border border-green-200 dark:border-green-500/20 text-xs font-medium"
                >
                  <span class="w-2 h-2 rounded-full bg-green-500"></span>
                  Success
                </span>
              </td>
            </tr>

            <tr class="border-b border-slate-100 dark:border-slate-800">
              <td class="py-4">Company B</td>
              <td class="py-4">SMTP</td>
              <td>EDIFACT</td>
              <td>XML</td>
              <td>
                <span
                  class="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-400 border border-blue-200 dark:border-blue-500/20 text-xs font-medium"
                >
                  <span class="w-2 h-2 rounded-full bg-blue-500"></span>
                  Processing
                </span>
              </td>
            </tr>

            <tr>
              <td class="py-4">Cozentus</td>
              <td class="py-4">FTP</td>
              <td>JSON</td>
              <td>EDIFACT</td>
              <td>
                <span
                  class="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400 border border-amber-200 dark:border-amber-500/20 text-xs font-medium"
                >
                  <span class="w-2 h-2 rounded-full bg-amber-500"></span>
                  Pending
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- PARTNER ECOSYSTEM -->
    <!-- <div
      class="partner-card rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg dark:shadow-[0_0_40px_rgba(70,95,255,0.15)] p-6 mt-8"
    >
      <h3 class="text-xl font-semibold mb-6 text-slate-800 dark:text-white">
        Partner Ecosystem
      </h3>

      <div class="partner-wrapper">

        <div class="partner-node top">
          <span class="mt-">Partner A</span>
          <div class="node">A</div>
        </div>

        <div class="partner-node left">
          <div class="node">B</div>
          <span>Partner B</span>
        </div>

        <div class="center-node">AI</div>

        <div class="partner-node right">
          <div class="node">C</div>
          <span>Partner C</span>
        </div>

        <div class="partner-node bottom">
          <div class="node">D</div>
          <span>Partner D</span>
        </div>

        <div class="line top-line"></div>
        <div class="line left-line"></div>
        <div class="line right-line"></div>
        <div class="line bottom-line"></div>
      </div>
    </div> -->
  </div>
</div>
